module.exports = {
      id: "vietnam-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#vietnam-usage",
      toString: function () {
        return this.url;
      }
    }